import React, { PureComponent } from 'react'

import Keyboard from 'react-simple-keyboard';
import 'react-simple-keyboard/build/css/index.css';

// import style from './Keyboard.module.css';

// This cap is a backstop only — `disableButtonHold` below is what actually
// stops a stuck key repeating (DEV-12143: a dropped pointerup made
// react-simple-keyboard's hold-repeat type ~10 chars/sec forever, and every
// character reset the idle timer, so the kiosk never returned home).
//
// Both thresholds are set to separate machine cadence from human cadence: a
// hold-repeat fires on a fixed ~100ms interval and never pauses, while someone
// hunting keys on a full-height kiosk keyboard pauses far longer between taps.
// A gap this long counts as a pause and starts a new window. Set well above the
// repeat interval; it does not need to be below every human key-to-key time,
// because the cap below is what actually makes suppression unreachable for a
// person — a fast typist merely needs one ordinary pause within two minutes.
const IDLE_PING_GAP_MS = 750;
// Only after this much genuinely uninterrupted input do we stop resetting the
// idle timer. Generous on purpose: reaching it requires ~2 minutes of taps with
// every single gap under IDLE_PING_GAP_MS, which a person cannot realistically
// do, so a real visitor is never reset out of a search mid-typing. A runaway
// source is still bounded instead of suppressing the idle reset forever.
const IDLE_PING_MAX_CONTINUOUS_MS = 120000;

class KeyboardComponent extends PureComponent {
	constructor(props) {
		super(props);
        this.keyboard = null;
        this.lastKeyEventTs = 0;
        this.continuousInputStart = 0;
		this.state = {
            css: props.CSSModules["Keyboard"],
			keyboardLayoutType: this.props.defaultKeyboard || 'letters'
		}
	}

	componentDidMount() {
	}

    componentWillUnmount() {
        this.keyboard.destroy();
	}

    componentDidUpdate(prevProps) {
        if (prevProps.navProps.resetListings !== this.props.navProps.resetListings && this.props.navProps.resetListings === true) {
            this.props.setInputValue('');
            this.keyboard.setInput('');
		}

        if(this.props.searchUpdater) {
            if (prevProps.searchUpdater !== this.props.searchUpdater) {
                this.props.setInputValue('');
                this.keyboard.setInput('');
            }
        }

        if((this.props.navProps.timeoutStatus !== prevProps.navProps.timeoutStatus && !this.props.navProps.timeoutStatus) && (this.props.navProps.animationPhase === this.props.navProps.animationStartPhase)) {
            this.props.setInputValue('');
            this.keyboard.setInput('');
        }
    }

    pingIdleTimer = (label) => {
        const now = Date.now();
        if (now - this.lastKeyEventTs > IDLE_PING_GAP_MS) {
            this.continuousInputStart = now;
        }
        this.lastKeyEventTs = now;
        if (now - this.continuousInputStart <= IDLE_PING_MAX_CONTINUOUS_MS) {
            this.props.navEvents('idleTimer', label);
        }
    }

    handleKeyboardOnChange = (input) => {
        this.pingIdleTimer('||| Keyboard.js > handleKeyboardOnChange');

        this.props.setInputValue(input);
        this.props.closeDetailsPage();
        this.props.setDetailsTitle('');
        this.props.setTieredHeadersAndDetails([], []);
        this.props.setHistory([]);
    }

    handleKeyboardOnKeyPress = (button) => {
        this.pingIdleTimer('||| Keyboard.js > handleKeyboardOnKeyPress');
        
        if (!this.props.navProps.hasNavigatedListings) {
            this.props.navEvents('setHasNavigatedListings', true);
        }
        
        switch (button) {
            case '{clear}':
                this.props.setInputValue('')
                this.keyboard.setInput('');
                break;
            case '{switchToNumbers}':
                this.setState({ keyboardLayoutType: 'numbers'})
                break;
            case '{switchToLetters}':
                this.setState({ keyboardLayoutType: 'letters'})
                break;
            case '{switchToSpecialChars}':
                this.setState({ keyboardLayoutType: 'specialChars'})
                break;
            default:
                break;
        }
    }

    handleChildElementClick = (e) => {
        e.stopPropagation()
    }

    render() {
        let css = this.state.css;
        let keyboardLayout = []
        switch (this.state.keyboardLayoutType) {
            case "letters":
              keyboardLayout = [
                "q w e r t y u i o p",
                "a s d f g h j k l",
                "z x c v b n m {bksp}",
                "{switchToNumbers} {space} {switchToSpecialChars}",
              ];
              break;
            case "numbers":
              keyboardLayout = [
                "1 2 3 4 5 6 7 8 9 0",
                "- / : ; ( ) $ & @ \"",
                ". , ? ! ' {bksp}",
                "{switchToLetters} {space} {switchToSpecialChars}",
              ];
              break;
            case "specialChars":
              keyboardLayout = [
                "á ä ã à â ú ü û",
                "é è ê ë í î ï ñ",
                "ô ö õ ø ó ç ý {bksp}",
                "{switchToNumbers} {space} {switchToLetters}",
              ];
              break;
            default:
              break;
        }
        return (
            <div className={`keyboardContainer ${css.keyboardContainer} ${this.props.isKeyboardHidden && css.hideKeyboard}`} onClick={(e) => {
                e.preventDefault();
                this.props.hideKeyboard()
            }} onTouchEnd={(e) => {
                e.preventDefault();
                this.props.hideKeyboard()
            }}>
                <div
                    className={css.normalizeKeyboard}
                    onClick={(e) => this.handleChildElementClick(e)}
                    onTouchEnd={(e) => e.stopPropagation()}
                >
                    <Keyboard
                        keyboardRef={r => (this.keyboard = r)}
                        disableButtonHold={true}
                        layoutName={'default'}
                        onChange={this.handleKeyboardOnChange}
                        onKeyPress={this.handleKeyboardOnKeyPress}
                        theme={`hg-theme-default hg-layout-default`}
                        display={{
                            '{bksp}': '⌫',
                            '{space}': 'space',
                            '{clear}': 'clear',
                            '{switchToNumbers}' : '123',
                            '{switchToLetters}' : 'abc',
                            '{switchToSpecialChars}' : 'áäã'
                        }}
                        layout={{
                            'default': keyboardLayout
                        }}
                        buttonTheme={[
                            {
                                class: "keyboardSpacebar",
                                buttons: "{space}"
                            }
                        ]}
                    />
                </div>
            </div>
        )
    }
}

export default KeyboardComponent

